import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CreateUpdatePartition from "pages/vending/partition/CreateUpdatePartition";
import React from "react";

const PartitionCrudDialog = ({
  open,
  handleClose,
  number,
  tray_id,
  setCurrentItem,
  partition,
}) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={() => {
        handleClose();
        setCurrentItem(null);
      }}
      heading={partition ? "Update partition" : "Create partition"}
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        <CreateUpdatePartition
          tray_id={tray_id}
          number={number}
          partition={partition}
        />
      </Box>
    </CustomDialog>
  );
};

export default PartitionCrudDialog;
